/*global jQuery*/
const $ = jQuery
export default () => {
  $('#responsiveTabsDemo').responsiveTabs({
    startCollapsed: 'accordion'
  })
}



// WEBPACK FOOTER //
// ./src/js/_tabs.js